// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"a4cdc228","213":"74252e09","400":"986af690","667":"2d651651","673":"749c5180"}[chunkId] + ".chunk.js";
};